<template>
   <vue-excel-xlsx
      :data="items"
      :columns = "convertToExcelLabel(headers)"
      :file-name="'File-Excel'"
      :file-type="'xlsx'"
      :sheet-name="'sheetname'"
      >
      <v-list-item-title>
        <v-btn v-if="!buttonStyle" color="teal darken-4" class="my-2" small outlined>Xuất excel</v-btn>
        <v-btn v-if="buttonStyle=='text'" color="teal darken-4" class="my-2" text style="text-transform: none;">Xuất excel</v-btn>
        <v-btn v-if="buttonStyle=='bold'" color="teal darken-4" class="ml-2 rounded-xl" dark style="height: 40px !important;" depressed>
          <v-icon left>mdi-download</v-icon>
            Xuất excel
        </v-btn>
        
        <v-btn v-if="buttonStyle=='outlined'" outlined color="teal darken-4" class="mx-2 rounded-xl" dark style="height: 40px !important; text-transform: none;">
          <v-icon left>mdi-download</v-icon>
            Xuất excel
        </v-btn>
      </v-list-item-title>
  </vue-excel-xlsx>
</template>

<script>
export default {
  props:['headers', 'items', 'buttonStyle', 'height'],
  methods: {
    
    convertToExcelLabel(value) {
      if(Array.isArray(value)) {
          var exceptCols = ['actions']
          return value.filter(x=>!exceptCols.includes(x.value)).map(x => {
              return {
                  label: x.text,
                  field: x.value
              }
          })
      }
    },
  }

}
</script>